import {
    FONT_PRECONNECT_ORIGINS,
    ICON_FONT_STYLESHEET_HREFS,
    BASE_FONT_STYLESHEET_HREFS,
    SHARED_UI_HARDCODED_FONT_FAMILIES,
    resolveThemeFontStylesheets,
} from '@web-store-platforms/constants';

export {
    FONT_PRECONNECT_ORIGINS,
    ICON_FONT_STYLESHEET_HREFS,
    BASE_FONT_STYLESHEET_HREFS,
    SHARED_UI_HARDCODED_FONT_FAMILIES,
    resolveThemeFontStylesheets,
};

/**
 * Login critical path: only the publisher login/general font.
 * Skips shared-ui hardcoded families (e.g. Oswald) and icon kits.
 */
export function resolveLoginCriticalFontStylesheets(
    loginFont?: string | null,
    generalFont?: string | null,
): string[] {
    const family = loginFont || generalFont;
    if (!family) {
        return [];
    }
    return resolveThemeFontStylesheets([family]);
}
